/**
 * Client mirror of `netlify/functions/_lib/cylinder-program.ts` — the Vite
 * bundle cannot import a function lib. `tests/cylinder-program.test.ts`
 * fails when the two disagree. Change the fee THERE first.
 */
export const LOST_CYLINDER_FEE = 165;

export interface CountEntryLike {
  label: string;
  system_count: number;
  counted: number;
}

export function missingTanks(entries: ReadonlyArray<CountEntryLike>): number {
  let missing = 0;
  for (const e of entries) {
    const short = Number(e.system_count) - Number(e.counted);
    if (Number.isFinite(short) && short > 0) missing += Math.floor(short);
  }
  return missing;
}
